/** Top-level `diagnosis_content.source` values from tracker Goal API. */
export const PLAN_DIAGNOSIS_SOURCE = {
  ONBOARDING_V3_0_1: "onboarding_v3_0_1",
} as const;
